import { Route } from 'types/route.type';
import BluViuNutrition from 'views/bluviu-nutrition/components/bluviu-nutrition';
import ScenarioOverview from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-overview';

export const routes: Route[] = [
  {
    path: '/bluviu-nutrition/:tab/:globalSiteId?/',
    component: BluViuNutrition,
    id: 'bluViuNutrition.navigation.listBluViuNutritionR2',
  },
  {
    path: '/bluviu-nutrition/:tab(r2)/:globalSiteId/:scenarioId/:subTab',
    component: ScenarioOverview,
    id: 'bluViuNutrition.navigation.listBluViuNutritionR2',
  },
];
